export const ACCOUNT_MESSAGES = {
    account: "حساب‌کاربری",
    myCourses: "دوره‌های من",
    seoDescription: "دوره‌هایی که در آن‌ها ثبت‌نام کرده‌اید.",
    loading: "در حال بارگذاری دوره‌ها...",
    failed: "دریافت دوره‌ها با مشکل مواجه شد.",
    empty: "هنوز در دوره‌ای ثبت‌نام نکرده‌اید.",
    lessons: "درسنامه",
    cheatsheet: "تقلب‌نامه",
    buyCourse: "خرید دوره"
};